import { NgModule } from '@angular/core';
import { Routes,RouterModule } from '@angular/router';
import { SignupComponent } from "./signup/signup.component";

const companyRoutes: Routes = [
    {path: 'register',children: [
    {path: '', component: SignupComponent}
    ]}
  ];
@NgModule({
  imports: [
    RouterModule.forChild(companyRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class CompaniesRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/companies/companies-routing.module.ts